import { Box, SxProps, Theme, Typography } from '@mui/material';

import { DocWithMagnifyingGlassIllustration } from '../../../illustrations';

const customStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 0',
  },
  illustration: {
    width: '120px',
    height: '120px',
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    color: (theme: Theme) => theme.palette.text.primary,
    textAlign: 'center',
  },
};

export function FilterEmptyState({ text }: { text: string }) {
  return (
    <Box sx={customStyles.container}>
      <DocWithMagnifyingGlassIllustration sx={customStyles.illustration} />
      <Typography sx={customStyles.text}>{text}</Typography>
    </Box>
  );
}
